import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API, UPLOADS } from "../../config/api";
import "./../Styles/profile.css";

export default function Profile() {
  const navigate = useNavigate();

  const [profileImage, setProfileImage] = useState(null);
  const [preview, setPreview] = useState("");

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
    state: "",
    role: "",
    account_type: "",
    status: "",
    profile_image: "",
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    const user = JSON.parse(sessionStorage.getItem("user"));

    if (!user) {
      navigate("/");
      return;
    }

    try {
      const res = await fetch(`${API.GET_USER}&id=${user.id}`);

      const data = await res.json();

      if (data.success) {
        setForm({
          name: data.user.name || "",
          email: data.user.email || "",
          phone: data.user.phone || "",
          city: data.user.city || "",
          state: data.user.state || "",
          role: data.user.role || "",
          account_type: data.user.account_type || "",
          status: data.user.status || "",
          profile_image: data.user.profile_image || "",
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setProfileImage(file);

      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const user = JSON.parse(sessionStorage.getItem("user"));

    try {
      const fd = new FormData();

      fd.append("id", user.id);
      fd.append("name", form.name);
      fd.append("email", form.email);
      fd.append("phone", form.phone);
      fd.append("city", form.city);
      fd.append("state", form.state);
      fd.append("role", form.role);
      fd.append("account_type", form.account_type);
      fd.append("status", form.status);

      // send image
      if (profileImage) {
        fd.append("profile_image", profileImage);
      }

      const res = await fetch(API.UPDATE_PROFILE, {
        method: "POST",
        body: fd,
      });

      const data = await res.json();

      if (data.success) {
        const updatedUser = {
          ...user,
          ...form,
          profile_image: data.profile_image || form.profile_image,
        };

        setForm((prev) => ({
          ...prev,
          profile_image: data.profile_image || prev.profile_image,
        }));

        sessionStorage.setItem("user", JSON.stringify(updatedUser));

        window.dispatchEvent(new Event("userLogin"));

        alert("Profile Updated Successfully");

        fetchProfile();
      } else {
        alert(data.message || "Update failed");
      }
    } catch (err) {
      console.log(err);
      alert("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => navigate(-1);

  return (
    <div className="usr-modl-backdrop" onClick={handleClose}>
      <div className="usr-prof-container" onClick={(e) => e.stopPropagation()}>
        <button className="usr-dismiss-trigger" onClick={handleClose}>
          ✕
        </button>

        <div className="usr-headline-group">
          <h3 className="usr-main-title">My Profile</h3>

          <p className="usr-sub-title">Update your personal information</p>
        </div>

        {/* PROFILE IMAGE */}

        <div className="profile-avatar-box">
          <label htmlFor="profileUpload">
            {preview ? (
              <img src={preview} className="profile-avatar" />
            ) : form.profile_image ? (
              <img
                src={`${UPLOADS.PROFILE_IMAGE}${form.profile_image}`}
                className="profile-avatar"
              />
            ) : (
              <div className="profile-letter">
                {form.name ? form.name.charAt(0).toUpperCase() : "U"}
              </div>
            )}

            <div className="profile-edit-icon">
              <i className="bi bi-pencil-fill"></i>
            </div>
          </label>

          <input
            id="profileUpload"
            type="file"
            accept="image/*"
            hidden
            onChange={handleImageChange}
          />
        </div>

        <form onSubmit={handleSubmit} className="usr-sheet-form">
          <div className="usr-input-wrapper">
            <label className="usr-field-label">Full Name</label>

            <input
              type="text"
              name="name"
              className="usr-text-control"
              value={form.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="usr-input-wrapper">
            <label className="usr-field-label">Email Address</label>

            <input
              type="email"
              name="email"
              className="usr-text-control"
              value={form.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="usr-dual-column">
            <div className="usr-input-wrapper">
              <label className="usr-field-label">Phone Number</label>

              <input
                type="tel"
                name="phone"
                className="usr-text-control"
                value={form.phone}
                onChange={handleChange}
              />
            </div>

            <div className="usr-input-wrapper">
              <label className="usr-field-label">Role</label>

              <input
                type="text"
                value={form.role}
                readOnly
                className="usr-text-control usr-immutable-field"
              />
            </div>
          </div>

          <div className="usr-dual-column">
            <div className="usr-input-wrapper">
              <label className="usr-field-label">City</label>

              <input
                type="text"
                name="city"
                className="usr-text-control"
                value={form.city}
                onChange={handleChange}
              />
            </div>

            <div className="usr-input-wrapper">
              <label className="usr-field-label">State</label>

              <input
                type="text"
                name="state"
                className="usr-text-control"
                value={form.state}
                onChange={handleChange}
              />
            </div>
          </div>

          <button
            type="submit"
            className="usr-action-commit"
            disabled={loading}
          >
            {loading ? "Saving..." : "Update Profile"}
          </button>
        </form>
      </div>
    </div>
  );
}
